export default __webpack_public_path__ + "images/2N.93c1be5.png";